import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=c81139c6&scoped=true&"
import script from "./Past.vue?vue&type=script&lang=js&"
export * from "./Past.vue?vue&type=script&lang=js&"
import style0 from "./Past.vue?vue&type=style&index=0&id=c81139c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81139c6",
  null
  
)

export default component.exports